// Note: CC is missing a convention how to format numbers in which locale and with which precision.
// Right now in many places a pseudo-german locale is hardcoded.
// This should be done by a proper library, but for now we refactored common number formatting to a central place

export const formatUnit = (v: number, unit: string) =>
  `${v.toFixed(2).replace('.', ',')} ${unit}`;
